import { faChevronDown, faChevronUp } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";

interface IWebsiteBuilderHoverSettingsProps {
  children: ReactNode;
}

export function WebsiteBuilderHoverSettings(props: IWebsiteBuilderHoverSettingsProps) {
  const { children } = props;

  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  return (
    <div className="website-builder-hover-settings">
      <button
        type="button"
        className="hover-settings-trigger"
        aria-expanded={open}
        onClick={() => setOpen(previous => !previous)}
      >
        <span>{t("Hover")}</span>
        <FontAwesomeIcon icon={open ? faChevronUp : faChevronDown} />
      </button>
      {open && <div className="hover-settings-content">{children}</div>}
    </div>
  );
}
